import { graphql, HttpResponse } from 'msw'
import { type EnrollmentHYCSFundAccountData, type EnrollmentHYCSFundAccountSubmitOutput } from '../../../../models'

export const getEnrollmentHYCSFundAccountDataMock: EnrollmentHYCSFundAccountData = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/hycs/fund-account',
  enrollmentData: {
    applicationId: '305802305',
  },
  complete: false,
}

export const submitEnrollmentHYCSFundAccountDataMock: EnrollmentHYCSFundAccountSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  enrollmentData: {
    applicationId: '305802305',
  },
  complete: true,
  path: '/enrollment/hycs/fund-success',
}

export const getEnrollmentHYCSPlaidTokenMock: EnrollmentHYCSFundAccountSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  complete: false,
  enrollmentData: {
    plaidLinkToken: 'plaid-link-token',
  },
}

export const mockGetEnrollmentHYCSFundAccountData = graphql.mutation('getEnrollmentHYCSFundAccountData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSFundAccountDataMock } })
})

export const mockGetEnrollmentyHYCSFundAccountPlaidToken = graphql.mutation('getEnrollmentyHYCSPlaidToken', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentHYCSPlaidTokenMock } })
})

export const mockSubmitEnrollmentHYCSFundAccountData = graphql.mutation('submitEnrollmentHYCSFundAccountData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentHYCSFundAccountDataMock } })
})

export const mockEnrollmentHYCSFundAccount = [
  mockGetEnrollmentHYCSFundAccountData,
  mockSubmitEnrollmentHYCSFundAccountData,
  mockGetEnrollmentyHYCSFundAccountPlaidToken,
]
